export default {
  "content": "<g clip-path=\"url(#clip0_3780_563)\"><path d=\"M0 4a4 4 0 014-4h28a4 4 0 014 4v16a4 4 0 01-4 4H4a4 4 0 01-4-4V4z\" fill=\"#008CFF\"/><path d=\"M24.116 8.1c0-1.016-.214-1.82-.688-2.6l-4.1.827c.26.544.426 1.205.426 2.175 0 1.773-1.257 4.372-2.276 6.027l-1.09-8.746-4.504.426L13.946 18.5h5.144c2.252-2.954 5.026-7.162 5.026-10.4z\" fill=\"#fff\"/></g><defs><clipPath id=\"clip0_3780_563\"><path fill=\"#fff\" d=\"M0 0h36v24H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "36",
    "height": "24",
    "viewBox": "0 0 36 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};